/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService
 */

export let ComHubspotCommerceToolSenderModelsEmailValidationErrors;
(function (_ComHubspotCommerceToolSenderModelsEmailValidationErrors) {})(ComHubspotCommerceToolSenderModelsEmailValidationErrors || (ComHubspotCommerceToolSenderModelsEmailValidationErrors = {}));
export let ComHubspotCommerceToolSenderModelsEmailValidationErrorsEmailaddress;
(function (_ComHubspotCommerceToolSenderModelsEmailValidationErrorsEmailaddress) {})(ComHubspotCommerceToolSenderModelsEmailValidationErrorsEmailaddress || (ComHubspotCommerceToolSenderModelsEmailValidationErrorsEmailaddress = {}));
export const getEmailSendPreviewRpc = {
  serviceName: 'com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService',
  rpcName: 'getEmailSendPreview',
  auth: 'app',
  fingerprint: 'lqa8nShvUUYEAksi71Y286V_dzK6E15R',
  na1Only: false,
  isStreaming: false
};
export const getEmailSendPreviewQuoteContextRpc = {
  serviceName: 'com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService',
  rpcName: 'getEmailSendPreviewQuoteContext',
  auth: 'app',
  fingerprint: 'CXWw-YUknu5UpXBsJc319KV_dzK6E15R',
  na1Only: false,
  isStreaming: false
};
export const getEmailContextForDebugRpc = {
  serviceName: 'com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService',
  rpcName: 'getEmailContextForDebug',
  auth: 'app',
  fingerprint: 'B3Fbmm5QfWPUHbmgnIkxH6V_dzK6E15R',
  na1Only: false,
  isStreaming: false
};
export const sendEmailRpc = {
  serviceName: 'com.hubspot.commerce.tool.sender.rpc.CommerceToolSenderEmailService',
  rpcName: 'sendEmail',
  auth: 'app',
  fingerprint: 'vLThI8CLRUCl5kZV7CU5mqV_dzK6E15R',
  na1Only: false,
  isStreaming: false
};